<script setup lang="ts">
import { useTranslate } from "addeus-common-library/stores/translate";
import ImageHeader from "../../../components/website/ImageHeader.vue";
import BlockHoverAnimated from "../../../components/website/BlockHoverAnimated.vue";
import Footer from "../../../components/website/Footer.vue";
import { useSeoMeta } from "../../../composables/useSeoMeta";

const { setTranslateNamespace } = useTranslate();
setTranslateNamespace(".kart");

useSeoMeta({
    title: "Karting électrique | Runs, anniversaires, EVG et afterworks",
    description:
        "Toutes nos formules de karting électrique indoor : runs chronométrés, anniversaires enfants dès 7 ans, EVG/EVJF Wedding Kart Race et afterworks entre collègues. Réservez en ligne.",
    path: "/kart",
    breadcrumbs: [
        { name: "Accueil", path: "/" },
        { name: "Faire du kart", path: "/kart" },
    ],
    schemaOrg: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "Quelles formules de karting sont disponibles chez Speed2Max ?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Speed2Max propose 4 formules : les Runs (sessions chronométrées), les Anniversaires (dès 7 ans), les EVG/EVJF (Wedding Kart Race) et les Afterworks (soirées entre collègues).",
                },
            },
            {
                "@type": "Question",
                name: "À partir de quel âge peut-on faire du karting électrique ?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Le karting électrique Speed2Max est accessible dès 7 ans. Des karts adaptés sont disponibles pour chaque tranche d'âge.",
                },
            },
            {
                "@type": "Question",
                name: "Le karting Speed2Max est-il 100% électrique ?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Oui, tous les karts Speed2Max sont 100% électriques : zéro émission, zéro bruit de moteur thermique, pour une expérience indoor agréable et responsable.",
                },
            },
        ],
    },
});
</script>

<template>
    <VFlex flex-direction="column">
        <ImageHeader>
            <template #image>
                <img
                    src="/images/kart/faireDuKart/bg-faire-du-kart.jpg"
                    alt="Formules de karting électrique Speed2Max" />
            </template>
            <template #title>
                <span> <Translate path=".titleP1"></Translate>&nbsp;</span>
                <span class="has-text-primary">
                    <Translate path=".titleP2"></Translate>
                </span>
            </template>
            <template #subtitle>
                <Translate path=".subtitle"></Translate>
            </template>
            <template #icon>
                <img
                    src="/images/kart/icon-faire-du-kart.svg"
                    alt="Icône karting électrique" />
            </template>
        </ImageHeader>
        <TranslateNamespace path=".nav">
            <VFlex
                column-gap="1rem"
                row-gap="1rem"
                class="has-background-dark p-6 flex-card-anchor">
                <TranslateNamespace path=".runs">
                    <BlockHoverAnimated to="/kart/runs">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
                <TranslateNamespace path=".birthday">
                    <BlockHoverAnimated to="/kart/birthday">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content1"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
                <TranslateNamespace path=".evgjf">
                    <BlockHoverAnimated to="/kart/evgjf">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
                <TranslateNamespace path=".afterWorks">
                    <BlockHoverAnimated to="/kart/afterWork">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <Footer></Footer>
    </VFlex>
</template>
<style lang="scss">
.image-header-content-title {
    > span {
        font-family: Mohol;
    }
}

.flex-card-anchor {
    display: grid !important;
}

.card-anchor {
    &:nth-child(1) {
        &::before {
            background-image: url("/images/kart/faireDuKart/FDK-anchor-runs.jpg");
        }
    }

    &:nth-child(2) {
        &::before {
            background-image: url("/images/kart/faireDuKart/FDK-anchor-anniversary.jpg");
        }
    }

    &:nth-child(3) {
        &::before {
            background-image: url("/images/kart/faireDuKart/FDK-anchor-evgjf.jpg");
        }
    }

    &:nth-child(4) {
        &::before {
            background-image: url("/images/kart/faireDuKart/FDK-anchor-afterWork.jpg");
        }
    }
}

@media (min-width: 790px) {
    .flex-card-anchor {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1300px) {
    .flex-card-anchor {
        grid-template-columns: repeat(4, 1fr);
    }

    .card-anchor {
        min-height: 450px;
    }
}
</style>
